<!-- This template will be replaced with the Chip Group component from CL-1175. -->
@let firstChip = first();

@if (firstChip) {
  <span class="tw-flex tw-min-w-0 tw-items-center tw-gap-1">
    <button
      bit-chip-action
      class="tw-min-w-0"
      [startIcon]="icon()"
      type="button"
      variant="subtle"
      [label]="firstChip.name"
      [title]="firstChip.name"
      [attr.aria-label]="filterLabel()"
      (click)="chipSelect.emit(firstChip.value)"
    ></button>

    @if (overflow() > 0) {
      <!-- No-op for the this button for now, will be reworked in CL-1175 to open a popover with the remaining chips. -->
      <button
        bit-chip-action
        class="tw-shrink-0"
        type="button"
        variant="subtle"
        [label]="'+' + overflow()"
        [title]="overflowNames()"
      ></button>
    }
  </span>
} @else {
  <span class="tw-text-muted" aria-hidden="true">&mdash;</span>
  <span class="tw-sr-only">{{ emptyLabel() }}</span>
}
